import { isEqual } from '@golden/utils';
import { NowTime } from '@golden/gdk-base';
import { computed, ref, watch } from 'vue';
export const useAsyncComputed = (asyncFunc, source, defaultValue) => {
    const queue = ref([]);
    const result = computed(() => queue.value?.[0]?.data ?? defaultValue);
    watch(source, async () => {
        const time = NowTime.get().getTime();
        queue.value.push({ time, complete: false, data: defaultValue });
        const data = await asyncFunc();
        const newQueue = queue.value.map((el) => el.time === time ? ({ ...el, complete: true, data }) : el);
        if (isEqual(queue, newQueue))
            return;
        const latest = Math.max(...newQueue.filter((el) => el.complete).map((el) => el.time));
        queue.value = newQueue.filter((el) => el.time >= latest);
    }, { immediate: true, deep: true });
    return result;
};
//# sourceMappingURL=useAsyncComputed.js.map